import axios from "axios";
import { AppointmentInformation, DashboardInformationFilters, ProcessDashboardRow } from "../types/processDashboard";

export class DashboardServices {
    private readonly url: string = "/api/process-dashboard";

    public async getDashboardInformation(filters: DashboardInformationFilters, pageNumer: number): Promise<ProcessDashboardRow[]> {
        const response = await axios.get<ProcessDashboardRow[]>(this.url, {
            params: { fechaInicial: filters.fechaInicial, fechaFinal: filters.fechaFinal, numeroPagina: pageNumer },
        });
        const { data } = response;
        return data;
    }

    public async getProcessInformationByCitaId(citaId: number): Promise<AppointmentInformation> {
        const response = await axios.get<AppointmentInformation>(`${this.url}/${citaId}`);
        const { data } = response;
        return data;
    }
}
